export default __webpack_public_path__ + "static/media/Actualización de datos 1 ‐ Made with Clipchamp.6748e217.mp3";